@if (!habilitaAsegurado) {
  <div class="row m-0 p-1">
    <div class="col-md-12 my-4 overflow-auto">
      <table mat-table multiTemplateDataRows [dataSource]="datosServiciosAsegurados.data | slice:(paginatorInfo?.pageStart ? paginatorInfo?.pageStart - 1 : 0):paginatorInfo?.pageEnd"
        class="table d-xl-table d-md-table d-sm-table d-table  table-responsive my-2">
        <ng-container matColumnDef="Servicio">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Servicio</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.descripl_dato}}</td>
        </ng-container>
        <ng-container matColumnDef="Reporte">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Reporte</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.reporte}}</td>
        </ng-container>
        <ng-container matColumnDef="Estatus">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Estatus</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_status}}</td>
        </ng-container>
        <ng-container matColumnDef="Acciones">
          <th mat-header-cell class="px-2" *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="mx-1">
            <div class="row justify-content-center">
              <div class="col-md-auto">
                <button color="primary" mat-raised-button type="button"
                  (click)="abrirSeccionServicios(element)" [disabled]="false">
                  <i class="fas fa-edit"></i>
                </button>
              </div>
            </div>
          </td>
        </ng-container>
        <!-- Sin resultados -->
        <ng-container matColumnDef="noData">
          <td mat-footer-cell *matFooterCellDef colspan="4">
            <small>No se encontró ningún resultado</small>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;"> </tr>
        <tr mat-footer-row *matFooterRowDef="['noData']"
          [ngClass]="(datosServiciosAsegurados?.data?.length === 0) ? '':'ocultarPaginator'">
        </tr>
      </table>
      <app-pagina-datos-tabla (eventPaginator)="paginatorInfo = $event" (click)="$event.stopPropagation()"
        [style.visibility]="datosServiciosAsegurados?.data?.length >= 6 ? 'visible' : 'hidden'"
        [showFisrtLastButton]="true" [registerPerPage]="5" [totalLength]="datosServiciosAsegurados?.data?.length">
      </app-pagina-datos-tabla>
    </div>
  </div>
}

@if (habilitaAsegurado) {
  <div class="row m-0 p-1" [formGroup]="formAsegurado">
    <div class="col-md-12">
      <mat-form-field class="inputFormularioSmall">
        <mat-label>Servicio:</mat-label>
        <mat-select formControlName="servicio">
          @for (t of catServicio; track t) {
            <mat-option [value]="t.valor_dato">{{ t.descripl_dato }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if ([1, 3].includes(this.formAsegurado.get('servicio').value)) {
      <div class="col-md-12">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Tipo proveedor:</mat-label>
          <input matInput type="text" formControlName="tipoProveedor">
        </mat-form-field>
      </div>
    }
    @if ([1, 3, 5, 15, 17, 10, 16, 15, 23].includes(this.formAsegurado.get('servicio').value)) {
      <div class="col-md-6">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Proveedor:</mat-label>
          <input matInput type="text" formControlName="proveedor">
        </mat-form-field>
      </div>
    }
    @if ([5, 15].includes(this.formAsegurado.get('servicio').value)) {
      <div class="col-md-12">
        <mat-form-field class="inputFormularioSmall">
          <mat-label>Folio reporte:</mat-label>
          <input matInput type="text" formControlName="reporte" UpperCase>
        </mat-form-field>
      </div>
    }
    @if (![1, 3].includes(this.formAsegurado.get('servicio').value)) {
      @if ([5].includes(this.formAsegurado.get('servicio').value)) {
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-8 row">
              <!-- Estatus -->
              <div class="col-md-12">
                <mat-form-field class="inputFormularioSmall">
                  <mat-label>Estatus:</mat-label>
                  <mat-select formControlName="estatus">
                    @for (ec of catConsultaEstatusConcepto; track ec) {
                      <mat-option [value]="ec.valor_dato">
                        {{ ec.descripl_dato }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              @if (![2].includes(this.formAsegurado.get('estatus').value)) {
                <!-- Evento -->
                <div class="col-md-12">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>Evento:</mat-label>
                    <mat-select formControlName="evento">
                      @for (tipo of catConsultaEventoServicio; track tipo) {
                        <mat-option
                          [value]="tipo.valor_dato">{{
                          tipo.descripl_dato }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Tiempo -->
                @if (this.formAsegurado.get('evento').value != 2) {
                  <div class="col-md-6">
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Fecha arribo:</mat-label>
                      <input matInput [matDatepicker]="fechaArribo" formControlName="fechaArribo" />
                      <mat-datepicker-toggle matSuffix [for]="fechaArribo"></mat-datepicker-toggle>
                      <mat-datepicker #fechaArribo></mat-datepicker>
                    </mat-form-field>
                  </div>
                }
                @if (this.formAsegurado.get('evento').value != 2) {
                  <div class="col-md-6 d-flex gap-2">
                    <mat-form-field class="campos-administrador" style="width: 90px;">
                      <mat-label>Hora arribo:</mat-label>
                      <mat-select formControlName="horaArribo">
                        @for (hora of horas; track hora) {
                          <mat-option [value]="hora">{{ hora }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <span class="align-self-center">:</span>
                    <mat-form-field appearance="fill" class="campos-administrador" style="width: 100px;">
                      <mat-label>Minuto arrribo:</mat-label>
                      <mat-select formControlName="minutosArribo">
                        @for (minuto of minutos; track minuto) {
                          <mat-option [value]="minuto">{{ minuto
                          }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                @if (this.formAsegurado.get('evento').value != 2) {
                  <div class="col-md-12 d-flex gap-2">
                    <mat-form-field class="campos-administrador" style="width: 90px;">
                      <mat-label>Hora espera:</mat-label>
                      <mat-select formControlName="horasTiempo">
                        @for (hora of horas; track hora) {
                          <mat-option [value]="hora">{{ hora }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <span class="align-self-center">:</span>
                    <mat-form-field appearance="fill" class="campos-administrador" style="width: 100px;">
                      <mat-label>Minuto espera:</mat-label>
                      <mat-select formControlName="minutosTiempo">
                        @for (minuto of minutos; track minuto) {
                          <mat-option [value]="minuto">{{ minuto
                          }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
              }
            </div>
            @if (![2].includes(this.formAsegurado.get('estatus').value)) {
              <div class="col-md-4 row">
                <!-- Maniobra Menor -->
                @if (this.formAsegurado.get('evento').value != 2) {
                  <div class="col-md-12">
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Maniobra mayor:</mat-label>
                      <mat-select formControlName="maniobraMayor">
                        @for (option of catSiNo; track option) {
                          <mat-option [value]="option.id">
                            {{ option.nombre }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                <!-- Grua Rescate -->
                @if (this.formAsegurado.get('evento').value != 2) {
                  <div class="col-md-12">
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Grúa Rescate:</mat-label>
                      <mat-select formControlName="gruaRescate">
                        @for (option of catSiNo; track option) {
                          <mat-option [value]="option.id">
                            {{ option.nombre }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                <!-- Blindaje -->
                @if (this.formAsegurado.get('evento').value != 2) {
                  <div class="col-md-12">
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Bindaje:</mat-label>
                      <mat-select formControlName="blindaje">
                        @for (option of catSiNo; track option) {
                          <mat-option [value]="option.id">
                            {{ option.nombre }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                <!-- Tipo Grua -->
                @if (servicioDetalle.ofnaprov == 'D00' ? this.servicioDetalle?.cve_prov == 384  : false) {
                  <div class="col-md-12"
                    >
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Tipo de Grúa:</mat-label>
                      <mat-select formControlName="tipoGrua">
                        @for (tipo of catGrua; track tipo) {
                          <mat-option [value]="tipo.valor_dato">{{
                            tipo.descripl_dato
                          }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                <!-- Resguardo -->
                @if (this.formAsegurado.get('evento').value != 2) {
                  <div class="col-md-12">
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Resguardo:</mat-label>
                      <mat-select formControlName="resguardo">
                        @for (option of catSiNo; track option) {
                          <mat-option [value]="option.id">
                            {{ option.nombre }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                <!-- Concesionada -->
                @if (this.formAsegurado.get('evento').value == 2) {
                  <div class="col-md-12">
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Concesionada:</mat-label>
                      <input matInput type="text" formControlName="concecionada" />
                    </mat-form-field>
                  </div>
                }
                <!-- Foránea -->
                @if (this.formAsegurado.get('evento').value != 2) {
                  <div class="col-md-12">
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Foránea:</mat-label>
                      <mat-select formControlName="foraneo">
                        @for (option of catSiNo; track option) {
                          <mat-option [value]="option.id">
                            {{ option.nombre }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
      @if ([16].includes(this.formAsegurado.get('servicio').value)) {
        <div class="col-md-12">
          <div class="row">
            <!-- Estatus -->
            <div class="col-md-12">
              <mat-form-field class="inputFormularioSmall">
                <mat-label>Estatus:</mat-label>
                <mat-select formControlName="estatus">
                  @for (ec of catConsultaEstatusConcepto; track ec) {
                    <mat-option [value]="ec.valor_dato">{{
                    ec.descripl_dato }}</mat-option>
                  }
                </mat-select>
                <mat-error>Campo requerido</mat-error>
              </mat-form-field>
            </div>
            <!-- Arribo -->
            @if (![2].includes(this.formAsegurado.get('estatus').value)) {
              <div class="col-md-6">
                <mat-form-field class="inputFormularioSmall">
                  <mat-label>Fecha arribo:</mat-label>
                  <input matInput [matDatepicker]="fechaArribo" formControlName="fechaArribo" />
                  <mat-datepicker-toggle matSuffix [for]="fechaArribo"></mat-datepicker-toggle>
                  <mat-datepicker #fechaArribo></mat-datepicker>
                </mat-form-field>
              </div>
              @if (this.formAsegurado.get('evento').value != 2) {
                <div class="col-md-6 d-flex gap-2">
                  <mat-form-field class="campos-administrador" style="width: 90px;">
                    <mat-label>Hora arribo:</mat-label>
                    <mat-select formControlName="horaArribo">
                      @for (hora of horas; track hora) {
                        <mat-option [value]="hora">{{ hora }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <span class="align-self-center">:</span>
                  <mat-form-field appearance="fill" class="campos-administrador" style="width: 100px;">
                    <mat-label>Minuto arrribo:</mat-label>
                    <mat-select formControlName="minutosArribo">
                      @for (minuto of minutos; track minuto) {
                        <mat-option [value]="minuto">{{ minuto
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
            }
          </div>
        </div>
      }
      <!-- Médico Responsiva -->
      @if ([16].includes(this.formAsegurado.get('servicio').value)) {
        <div class="col-md-4">
          <mat-form-field class="inputFormularioSmall">
            <mat-label>Médico y responsiva:</mat-label>
            <mat-select formControlName="medicoResponsiva">
              @for (option of catSiNo; track option) {
                <mat-option [value]="option.id">
                  {{ option.nombre }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if ([15].includes(this.formAsegurado.get('servicio').value)) {
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <div class="d-flex flex-column">
                <!-- Estatus -->
                <div class="col-md-12">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>Estatus:</mat-label>
                    <mat-select formControlName="estatus">
                      @for (ec of catConsultaEstatus; track ec) {
                        <mat-option [value]="ec.valor_dato">
                          {{ ec.descripl_dato }}
                        </mat-option>
                      }
                    </mat-select>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>
                <!-- Motivo Estatus -->
                <div class="col-md-12" [ngClass]="{'d-none' : !habilitaMotivoEstatus}">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>Motivo Estatus:</mat-label>
                    <input matInput formControlName="motivoEstatus" />
                  </mat-form-field>
                </div>
                <!-- Arribo -->
                @if (![2].includes(this.formAsegurado.get('estatus').value)) {
                  <div class="col-md-12">
                    <mat-form-field class="inputFormularioSmall">
                      <mat-label>Fecha arribo:</mat-label>
                      <input matInput [matDatepicker]="fechaArribo" formControlName="fechaArribo" />
                      <mat-datepicker-toggle matSuffix [for]="fechaArribo"></mat-datepicker-toggle>
                      <mat-datepicker #fechaArribo></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="col-md-12 d-flex gap-2">
                    <mat-form-field class="campos-administrador" style="width: 90px;">
                      <mat-label>Hora arribo:</mat-label>
                      <mat-select formControlName="horaArribo">
                        @for (hora of horas; track hora) {
                          <mat-option [value]="hora">{{ hora
                          }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <span class="align-self-center">:</span>
                    <mat-form-field appearance="fill" class="campos-administrador"
                      style="width: 100px;">
                      <mat-label>Minuto arrribo:</mat-label>
                      <mat-select formControlName="minutosArribo">
                        @for (minuto of minutos; track minuto) {
                          <mat-option [value]="minuto">{{ minuto
                          }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                <!-- MP -->
                <div class="col-md-12">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>MP:</mat-label>
                    <mat-select formControlName="mp">
                      @for (option of catMP; track option) {
                        <mat-option [value]="option.id">
                          {{ option.nombre }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Número Acta MP -->
                <div class="col-md-12">
                  <mat-form-field class="inputFormularioSmall">
                    <mat-label>Número de Acta MP:</mat-label>
                    <input matInput formControlName="numeroActaMP" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex flex-column">
                <div class="col-md-12">
                  <span>Tipo de Asunto:</span>
                </div>
                <!-- Homicidio -->
                <div class="col-md-12 d-flex gap-2">
                  <mat-checkbox formControlName="homicidio" (change)="validaCheck($event,  'totalhomicidio')">Homicidio
                    <span class="campo-lesionados align-self-center">
                      {{this.formAsegurado.get('homicidio').value ?
                      this.formAsegurado.get('totalhomicidio').value : ''}}
                    </span>
                  </mat-checkbox>
                  @if (this.formAsegurado.get('totalhomicidio').touched && this.formAsegurado.get('totalhomicidio').invalid) {
                    <small class="text-danger"
                      >
                      Requerido
                    </small>
                  }
                </div>
                <!-- Lesionado -->
                <div class="col-md-12 d-flex gap-2">
                  <mat-checkbox formControlName="lesionado"
                    (change)="validaCheck($event,  'totallesionado')">Lesionado
                    <span class="campo-lesionados align-self-center">
                      {{this.formAsegurado.get('lesionado').value ?
                      this.formAsegurado.get('totallesionado').value : ''}}
                    </span>
                  </mat-checkbox>
                  @if (this.formAsegurado.get('totallesionado').touched && this.formAsegurado.get('totallesionado').invalid) {
                    <small class="text-danger">Requerido</small>
                  }
                </div>
                <!-- Daños Materiales -->
                <div class="col-md-12">
                  <mat-checkbox formControlName="danosMateriales">Daños Materiales</mat-checkbox>
                </div>
                <!-- Daños Ecológicos -->
                <div class="col-md-12">
                  <mat-checkbox formControlName="danosEcologicos">Daños Ecológicos</mat-checkbox>
                </div>
                <!-- Ataques a la Vía -->
                <div class="col-md-12">
                  <mat-checkbox formControlName="ataquesViaComunicacion">Ataques Vía
                    Comunicación
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      @if ([17, 10].includes(this.formAsegurado.get('servicio').value)) {
        <!-- Tipo Lesión -->
        <div class="col-md-6">
          <mat-form-field class="inputFormularioSmall">
            <mat-label>Tipo Lesión:</mat-label>
            <input matInput formControlName="tipoLesion" type="text" [UpperCase]="true" />
          </mat-form-field>
        </div>
        <!-- Nombre Lesionado -->
        <div class="col-md-4">
          <mat-form-field class="inputFormularioSmall">
            <mat-label>Nombre Lesionado:</mat-label>
            <input matInput formControlName="nombreLesionado" type="text" [UpperCase]="true" />
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
        <!-- Apellido Paterno -->
        <div class="col-md-4">
          <mat-form-field class="inputFormularioSmall">
            <mat-label>Apellido Paterno:</mat-label>
            <input matInput formControlName="apellidoPaterno" type="text" [UpperCase]="true" />
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
        <!-- Apellido Materno -->
        <div class="col-md-4">
          <mat-form-field class="inputFormularioSmall">
            <mat-label>Apellido Materno:</mat-label>
            <input matInput formControlName="apellidoMaterno" type="text" [UpperCase]="true" />
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
        <!-- Edad -->
        <div class="col-md-4">
          <mat-form-field class="inputFormularioSmall">
            <mat-label>Edad:</mat-label>
            <input matInput type="number" formControlName="edad" maxlength="3" />
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
        <!-- Importe -->
        <div class="col-md-4 d-none">
          <mat-form-field class="inputFormularioSmall">
            <mat-label>Importe:</mat-label>
            <input matInput type="text" formControlName="importe" formatoMoneda tipoFormato="moneda" />
            @if (this.formAsegurado.get('importe').hasError('required')) {
              <mat-error>Campo
              obligatorio</mat-error>
            }
            @if (this.formAsegurado.get('importe').hasError('importeInvalido')) {
              <mat-error>
                Importe mayor a cero
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    }
    @if ([1, 3].includes(this.formAsegurado.get('servicio').value)) {
      <div formArrayName="coberturas" class="col-md-12 overflow-auto"
        >
        <table mat-table [dataSource]="coberturas.controls" class="mat-elevation-z2 table-responsive">
          <!-- Activa Column -->
          <ng-container matColumnDef="activa">
            <th mat-header-cell *matHeaderCellDef> Activa </th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <mat-checkbox class="mark-check-white" formControlName="activa" color="primary"
                (change)="ejecutaAccionesCoberturas(row, 'requiereEstimacion')">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="cobertura">
            <th mat-header-cell *matHeaderCellDef> Cobertura </th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              {{row.get('cobertura')?.value}}
            </td>
          </ng-container>
          <!-- Estimación Column -->
          <ng-container matColumnDef="estimacion">
            <th mat-header-cell *matHeaderCellDef> Estimación </th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <mat-form-field class="inputFormularioSmall">
                <mat-label>Estimación:</mat-label>
                <input matInput type="text" formControlName="estimacion" placeholder="Estimación" formatoMoneda
                  tipoFormato="moneda" maxlength="10"
                  (change)="ejecutaAccionesCoberturas(row, 'colocaOrdenServicio')" />
                  @if (row.get('estimacion').hasError('required')) {
                    <mat-error style="font-size: 9px;">
                      Campo requerido
                    </mat-error>
                  }
                  @if (row.get('estimacion').hasError('importeInvalido')) {
                    <mat-error style="font-size: 9px;">
                      La estimación debe ser diferente de 0
                    </mat-error>
                  }
                  @if (row.get('estimacion').hasError('sumaAsegurada')) {
                    <mat-error style="font-size: 9px;">
                      La estimación es mayor a la suma asegurada
                    </mat-error>
                  }
                </mat-form-field>
              </td>
            </ng-container>
            <!-- Deducible Column -->
            <ng-container matColumnDef="deducible">
              <th mat-header-cell *matHeaderCellDef> Deducible </th>
              <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                <mat-form-field class="inputFormularioSmall">
                  <mat-label>Deducible:</mat-label>
                  <mat-select formControlName="deducible">
                    @for (option of catSiNo; track option) {
                      <mat-option [value]="option.id">
                        {{ option.nombre }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="extra">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row; let i = index">
                {{row.get('extra')?.value}}
              </td>
            </ng-container>
            <ng-container matColumnDef="subcobertura">
              <th mat-header-cell *matHeaderCellDef> Sub Cob </th>
              <td mat-cell *matCellDef="let row; let i = index">
                {{row.get('notas')?.value}}
              </td>
            </ng-container>
            <!-- Header y Row Definitions -->
            <tr mat-header-row *matHeaderRowDef="columnasCoberturas"></tr>
            <tr mat-row *matRowDef="let row; columns: columnasCoberturas;"></tr>
          </table>
        </div>
      }
    </div>
  }
  @if (habilitaAsegurado) {
    <div class="row m-0 p-1 justify-content-end">
      <div class="col-md-auto d-flex justify-content-end">
        <button color="accent" mat-raised-button type="button" (click)="regresaConsulta()" [disabled]="false">
          Regresar
        </button>
      </div>
      <div class="col-md-auto d-flex justify-content-end">
        <button color="primary" mat-raised-button type="button" (click)="guardarActualizarServicio()"
          [disabled]="false">
          Guardar
        </button>
      </div>
    </div>
  }